












import { Component, Vue } from "vue-property-decorator";
import GlobalHeader from "@/containers/GlobalHeader.vue";
import GlobalFooter from "@/containers/GlobalFooter.vue";
import BreadCrumb from "@/components/BreadCrumb.vue";
//import AlertSummary from "@/components/AlertSummary.vue";
import AlertInformation from "@/components/AlertInformation.vue";
import { USER_ME, UserData } from "@/graphql/query/user/me";
import {
  ALL_GROUP_ALERTS,
  AlertData,
  AllAlertData
} from "@/graphql/query/alert/group";

@Component({
  components: { GlobalHeader, GlobalFooter, BreadCrumb,AlertInformation },
  apollo: {
    me: USER_ME,
    alertFeed: {
      query: ALL_GROUP_ALERTS
    }
  }
})
export default class HomeLayout extends Vue {
  me: UserData | null = null;
  alertFeed: any | null = null;
}
